"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _ = require("lodash");
var __1 = require("..");
var component_1 = require("./component");
var Axis = /** @class */ (function (_super) {
    __extends(Axis, _super);
    function Axis() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tickValues = [];
        _this.scales = [];
        return _this;
    }
    Axis.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_gravity":
                return {
                    top: __1.Gravity.Top, bottom: __1.Gravity.Bottom, left: __1.Gravity.Left, right: __1.Gravity.Right,
                }[value.toLowerCase()];
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Axis.prototype.defaultOptions = function () {
        return {
            _scale_isFunc: false,
            _gravity: __1.Gravity.Bottom,
            _includeStartEndTicks: true,
            _tickCount: 5,
            _removeOverlap: true,
        };
    };
    Axis.prototype.init = function () {
        this._options._size = [0, 0];
    };
    Axis.prototype.renderElement = function (node, d, i, g, h) {
        var direction = h.op("_gravity");
        var scale = this.getOption("_scale", d, i, g);
        this.scales[i] = scale;
        if (!scale) {
            return;
        }
        if (typeof this.axis === "undefined" ||
            this._isDirty("_gravity") || this._isDirty("_scale") ||
            this.getOption("_scale_isFunc")) {
            switch (direction) {
                case __1.Gravity.Top:
                    this.axis = d3.axisTop(scale);
                    break;
                case __1.Gravity.Bottom:
                    this.axis = d3.axisBottom(scale);
                    break;
                case __1.Gravity.Left:
                    this.axis = d3.axisLeft(scale);
                    break;
                case __1.Gravity.Right:
                    this.axis = d3.axisRight(scale);
                    break;
            }
        }
        var domain = scale.domain();
        if (domain.length === 2 && typeof domain[0] === "number") {
            var ticks = [];
            if (this._isDirty("_ticks")) {
                ticks = h.op("_ticks");
            }
            else {
                var interval = void 0;
                if (this._isDirty("_tickInterval")) {
                    interval = h.op("_tickInterval");
                }
                else {
                    var count = h.op("_tickCount");
                    var rawInterval_1 = (domain[1] - domain[0]) / count;
                    var digits_1 = baseDigitOf(rawInterval_1);
                    interval = _.minBy([0.1, 0.2, 0.5, 1, 2, 5].map(function (x) { return x * digits_1; }), function (x) {
                        if (x > domain[1]) {
                            return Number.MAX_SAFE_INTEGER;
                        }
                        return Math.abs(x - rawInterval_1);
                    });
                }
                // check whether domain[0] can be divided by interval
                var start = Math.ceil(domain[0] / interval) * interval;
                var counter = start;
                while (counter < domain[1]) {
                    ticks.push(counter);
                    counter += interval;
                }
            }
            if (ticks.length === 0) {
                ticks = scale.ticks();
            }
            var opt = h.op("_includeStartEndTicks");
            if (opt) {
                var domain_1 = scale.domain();
                ticks = ticks || scale.ticks();
                ticks = [domain_1[0]].concat(ticks).concat([domain_1[1]]);
                if (h.op("_removeOverlap")) {
                    if (Math.abs(scale(ticks[0]) - scale(ticks[1])) < 3 * (ticks[0].toString().length + ticks[1].toString().length)) {
                        ticks.splice(1, 1);
                    }
                    var last = ticks.length - 1;
                    if (Math.abs(scale(ticks[last]) - scale(ticks[last - 1])) < 3 * (ticks[last].toString().length + ticks[last - 1].toString().length)) {
                        ticks.splice(-2, 1);
                    }
                }
            }
            this.axis.tickValues(ticks);
            this.tickValues[i] = ticks;
        }
        node.classed("axis", true).call(this.axis);
    };
    return Axis;
}(component_1.Component));
exports.Axis = Axis;
function baseDigitOf(n) {
    var count = 1;
    if (n > 1) {
        while (n / 10 >= 1) {
            n /= 10;
            count *= 10;
        }
    }
    else {
        while (n * 10 <= 1) {
            n *= 10;
            count /= 10;
        }
    }
    return count;
}
//# sourceMappingURL=axis.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/axis.js
// module id = 420
// module chunks = 0 1